import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  getAttributionAvailabilityFailure: null,
  getAttributionAvailabilityRequest: null,
  getAttributionAvailabilitySuccess: ["availability"],

  getAttributionReportFailure: null,
  getAttributionReportRequest: ["cycle", "preview"],
  getAttributionReportSuccess: ["reportData"],

  getAttributionStudentsFailure: null,
  getAttributionStudentsRequest: ["cycle", "params"],
  getAttributionStudentsSuccess: ["studentsData"],
  clearAttributionStudents: null,

  getAttributionTimelineFailure: null,
  getAttributionTimelineRequest: ["cycle", "userId", "preview"],
  getAttributionTimelineSuccess: ["timeline"],
  clearAttributionTimeline: null,

  updateAttributionConfigFailure: null,
  updateAttributionConfigRequest: ["cycle", "changes"],
  updateAttributionConfigSuccess: ["config"],

  createAttributionNextStepRequest: ["cycle", "step"],
  updateAttributionNextStepRequest: ["cycle", "id", "changes"],
  deleteAttributionNextStepRequest: ["cycle", "id"],
  reorderAttributionNextStepsRequest: ["cycle", "orderedIds"],
  attributionNextStepsSuccess: ["nextSteps"],
  attributionNextStepsFailure: null,
});

export const AttributionReportTypes = Types;
export const AttributionReportCreators = Creators;
